(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3336],{

/***/ 88460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Card; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var _util_classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Card/meta.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



function Meta(props, ref) {
    var _a;
    var className = props.className, title = props.title, avatar = props.avatar, description = props.description, actionList = props.actionList, others = __rest(props, ["className", "title", "avatar", "description", "actionList"]);
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var prefixCls = getPrefixCls('card-meta');
    var classNames = (0,_util_classNames/* default */.Z)(prefixCls, className);
    return (react.createElement("div", __assign({}, others, { ref: ref, className: classNames }),
        title || description ? (react.createElement("div", { className: prefixCls + "-content" },
            title && react.createElement("div", { className: prefixCls + "-title" }, title),
            description && react.createElement("div", { className: prefixCls + "-description" }, description))) : null,
        avatar || actionList ? (react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-footer ", (_a = {}, _a[prefixCls + "-footer-only-actions"] = !avatar, _a)) },
            avatar ? react.createElement("div", { className: prefixCls + "-avatar" }, avatar) : null,
            actionList)) : null));
}
var MetaComponent = react.forwardRef(Meta);
MetaComponent.displayName = 'CardMeta';
/* harmony default export */ var meta = (MetaComponent);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Card/grid.js



function Grid(props, ref) {
    var _a;
    var children = props.children, style = props.style, className = props.className, hoverable = props.hoverable;
    var getPrefixCls = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_).getPrefixCls;
    var prefixCls = getPrefixCls('card-grid');
    return (react.createElement("div", { ref: ref, style: style, className: (0,_util_classNames/* default */.Z)(prefixCls, (_a = {}, _a[prefixCls + "-hoverable"] = hoverable, _a), className) }, children));
}
var CardComponent = react.forwardRef(Grid);
CardComponent.displayName = 'CardGrid';
/* harmony default export */ var grid = (CardComponent);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Spin/index.js + 1 modules
var Spin = __webpack_require__(62258);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Card/index.js
var Card_assign = (undefined && undefined.__assign) || function () {
    Card_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return Card_assign.apply(this, arguments);
};
var Card_rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};







var defaultProps = {
    size: 'default',
    bordered: true,
};
function Card(baseProps, ref) {
    var _a, _b;
    var _c = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _c.getPrefixCls, loadingElement = _c.loadingElement, componentConfig = _c.componentConfig, rtl = _c.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Card);
    var className = props.className, children = props.children, bordered = props.bordered, loading = props.loading, hoverable = props.hoverable, size = props.size, title = props.title, extra = props.extra, cover = props.cover, actions = props.actions, headerStyle = props.headerStyle, bodyStyle = props.bodyStyle, rest = Card_rest(props, ["className", "children", "bordered", "loading", "hoverable", "size", "title", "extra", "cover", "actions", "headerStyle", "bodyStyle"]);
    var prefixCls = getPrefixCls('card');
    var actionList = actions && actions.length ? (react.createElement("div", { className: prefixCls + "-actions" },
        react.createElement("div", { className: prefixCls + "-actions-right" }, actions.map(function (action, index) { return (react.createElement("span", { key: "action-" + index, className: prefixCls + "-actions-item" }, action)); })))) : null;
    var isContainGrid = false;
    var isContainMeta = false;
    var handledChildren = react.Children.map(children, function (element) {
        if (element && element.type) {
            if (element.type === grid) {
                isContainGrid = true;
            }
            else if (element.type === meta) {
                isContainMeta = true;
                return react.cloneElement(element, { actionList: actionList });
            }
        }
        return element;
    });
    return (react.createElement("div", Card_assign({}, rest, { ref: ref, className: (0,_util_classNames/* default */.Z)(prefixCls, prefixCls + "-size-" + size, (_a = {},
            _a[prefixCls + "-loading"] = loading,
            _a[prefixCls + "-bordered"] = bordered,
            _a[prefixCls + "-hoverable"] = hoverable,
            _a[prefixCls + "-contain-grid"] = isContainGrid,
            _a[prefixCls + "-rtl"] = rtl,
            _a), className) }),
        title || extra ? (react.createElement("div", { className: (0,_util_classNames/* default */.Z)(prefixCls + "-header", (_b = {}, _b[prefixCls + "-header-no-title"] = !title, _b)), style: headerStyle },
            title && react.createElement("div", { className: prefixCls + "-header-title" }, title),
            extra && react.createElement("div", { className: prefixCls + "-header-extra" }, extra))) : null,
        cover ? react.createElement("div", { className: prefixCls + "-cover" }, cover) : null,
        react.createElement("div", { className: prefixCls + "-body", style: bodyStyle },
            loading ? loadingElement || react.createElement(Spin/* default */.Z, null) : handledChildren,
            isContainMeta ? null : actionList)));
}
var ForwardRefCard = react.forwardRef(Card);
var Card_CardComponent = ForwardRefCard;
Card_CardComponent.Meta = meta;
Card_CardComponent.Grid = grid;
Card_CardComponent.displayName = 'Card';
/* harmony default export */ var es_Card = (Card_CardComponent);


/***/ }),

/***/ 88573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ es_Cascader; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/is.js
var is = __webpack_require__(53367);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Trigger/index.js + 2 modules
var Trigger = __webpack_require__(12830);
// EXTERNAL MODULE: ./node_modules/lodash/isEqualWith.js
var isEqualWith = __webpack_require__(28368);
var isEqualWith_default = /*#__PURE__*/__webpack_require__.n(isEqualWith);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/TransitionGroup.js + 1 modules
var TransitionGroup = __webpack_require__(73350);
// EXTERNAL MODULE: ./node_modules/react-transition-group/esm/CSSTransition.js
var CSSTransition = __webpack_require__(29697);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/classNames.js
var classNames = __webpack_require__(34855);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/Checkbox/index.js + 4 modules
var Checkbox = __webpack_require__(54224);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Cascader/panel/option.js


var Option = function (props) {
    var prefixCls = props.prefixCls, multiple = props.multiple, option = props.option, renderOption = props.renderOption, selected = props.selected, icons = props.icons;
    var checkboxDisabled = option.disabled || (multiple && option.disableCheckbox);
    return (react.createElement(react.Fragment, null,
        multiple ? (react.createElement(Checkbox/* default */.Z, { disabled: checkboxDisabled, checked: option._checked, indeterminate: option._halfChecked, onChange: props.onMultipleChecked, value: option.value })) : (''),
        react.createElement("div", { className: prefixCls + "-list-item-label", onClick: option.disabled ? undefined : props.onClickOption, onMouseEnter: props.onMouseEnter, onDoubleClick: checkboxDisabled ? undefined : props.onDoubleClickOption },
            renderOption ? renderOption() : option.label,
            option.isLeaf ? selected && icons.checked : option.loading ? icons.loading : icons.next)));
};
/* harmony default export */ var panel_option = (Option);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useRefs.js
// 保存一个ref列表

function useRefs(defaultValue) {
    if (defaultValue === void 0) { defaultValue = []; }
    var listRef = (0,react.useRef)(defaultValue);
    var setListRef = function (element, index) {
        if (index !== undefined) {
            listRef.current[index] = element;
        }
        else {
            listRef.current.push(element);
        }
    };
    return [listRef.current, setListRef];
}

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useForceUpdate.js
var useForceUpdate = __webpack_require__(65166);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/keycode.js
var keycode = __webpack_require__(85660);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useUpdate.js
var useUpdate = __webpack_require__(1083);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Cascader/base/node.js
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var Node = /** @class */ (function () {
    function Node(data, config, parent) {
        var _this = this;
        /** 当前选项节点路径的所有节点的值 */
        this.pathValue = [];
        this.pathLabel = [];
        this.config = {};
        this._initNode = function (option, parent) {
            if (parent === void 0) { parent = null; }
            var _a = _this.config, showEmptyChildren = _a.showEmptyChildren, lazyload = _a.lazyload;
            var fieldNames = __assign(__assign({}, DefaultFieldNames), _this.config.fieldNames);
            var children = option[fieldNames.children];
            var isLeaf = Array.isArray(children)
                ? showEmptyChildren
                    ? false
                    : children.length === 0
                : true;
            if (lazyload) {
                if (fieldNames.isLeaf in option) {
                    isLeaf = !!option[fieldNames.isLeaf];
                }
                else {
                    isLeaf = false;
                }
            }
            var nodeValue = option[fieldNames.value];
            var nodeLabel = option[fieldNames.label];
            var newOption = __assign(__assign({}, option), { value: nodeValue, label: nodeLabel, isLeaf: isLeaf, loading: false, loaded: false, disabled: (parent && parent.disabled) || option[fieldNames.disabled], parent: parent, pathValue: parent ? __spreadArray(__spreadArray([], __read(parent.pathValue), false), [nodeValue], false) : [nodeValue], pathLabel: parent ? __spreadArray(__spreadArray([], __read(parent.pathLabel), false), [nodeLabel], false) : [nodeLabel], _level: parent ? parent._level + 1 : 0, _checked: false, _halfChecked: false });
            _this._data = __assign(__assign({}, newOption), { parent: newOption.parent && newOption.parent._data });
            Object.keys(newOption).forEach(function (key) {
                _this[key] = newOption[key];
            });
            if (children && children.length) {
                _this.children = children.map(function (data, index) {
                    return new Node(__assign(__assign({}, data), { _index: index }), _this.config, _this);
                });
                _this._data.children = _this.children.map(function (node) { return node._data; });
            }
        };
        /**
         * 根据this.children 计算是否当前node半选状态
         * 假设半选是 0.5，全选是1，不选是0。
         * 那么只有当前节点的所有children加起来等于children.length，才是全选，否则和大于0，就是半选。
         */
        this._isHalfChecked = function () {
            var checkedLen = _this.children.reduce(function (total, prev) {
                var num = prev._halfChecked ? 0.5 : prev._checked ? 1 : 0;
                return total + num;
            }, 0);
            return checkedLen !== _this.children.length && checkedLen > 0;
        };
        /**
         *
         * @param checked 选中状态
         * @param ignoreDisabled 是否忽略节点禁用设置选中状态，一般在初始化设置选中状态时传参为true
         */
        this._setNodeChildrenChecked = function (checked, ignoreDisabled) {
            if (!ignoreDisabled && _this.disabled) {
                return;
            }
            if (_this.children && _this.children.length) {
                _this.children.forEach(function (item) {
                    if (item.disabled) {
                        if (ignoreDisabled) {
                            item.setCheckedStateIgnoreDisabled(checked);
                        }
                    }
                    else {
                        item.setCheckedState(checked);
                    }
                });
                _this.updateHalfState(checked);
            }
        };
        this.getSelfChildrenValue = function () {
            var result = [];
            var join = function (pathValue, nodes) {
                if (!nodes || !nodes.length) {
                    result.push(pathValue);
                    return;
                }
                (nodes || []).forEach(function (node) {
                    join(node.pathValue, node.children);
                });
            };
            join(_this.pathValue, _this.children);
            return result;
        };
        this.updateHalfState = function (checked) {
            _this._halfChecked = _this._isHalfChecked();
            _this._checked = _this._halfChecked ? false : checked;
        };
        // 直接设置选中状态
        this.setCheckedProperty = function (checked) {
            _this._checked = checked;
            _this._halfChecked = false;
        };
        // 设置当前节点选中状态
        this.setCheckedState = function (checked) {
            var noNeedToUpdate = checked ? _this._checked : !_this._checked && !_this._halfChecked;
            if (_this.disabled || noNeedToUpdate) {
                return;
            }
            _this.setCheckedProperty(checked);
            // 父子节点关联
            if (!_this.config.changeOnSelect) {
                _this._setNodeChildrenChecked(checked);
                var parent_1 = _this.parent;
                while (parent_1 && !parent_1.disabled) {
                    // 当半选状态时，设置_checked为false。保证点击半选状态的节点时，执行选中操作。
                    parent_1.updateHalfState(checked);
                    parent_1 = parent_1.parent;
                }
            }
        };
        // 忽略禁用设置选中状态
        this.setCheckedStateIgnoreDisabled = function (checked) {
            if (checked === Boolean(_this._checked)) {
                return;
            }
            _this.setCheckedProperty(checked);
            if (!_this.config.changeOnSelect) {
                _this._setNodeChildrenChecked(checked, true);
                var parent_2 = _this.parent;
                while (parent_2) {
                    // 当半选状态时，设置_checked为false。保证点击半选状态的节点时，执行选中操作。
                    parent_2.updateHalfState(checked);
                    parent_2 = parent_2.parent;
                }
            }
        };
        /**
         * 遍历节点的parent，获取当前节点的路径节点。
         * node: { label: '1-1-1', parent: { label: '1-1', parent: { label: '1' }, ... }, ...}
         * @return [node.parent.parent, node.parent, node]
         * @memberof Store
         */
        this.getPathNodes = function () {
            var nodes = [_this];
            var parent = _this.parent;
            while (parent) {
                nodes.unshift(parent);
                parent = parent.parent;
            }
            return nodes;
        };
        this.getChildren = function () {
            return _this.children;
        };
        this.setLoading = function (loading) {
            _this.loading = loading;
            if (loading || loading === undefined) {
                _this.loaded = false;
            }
            if (loading === false) {
                _this.loaded = true;
            }
        };
        this.config = config || {};
        this._initNode(data, parent || null);
    }
    return Node;
}());
/* harmony default export */ var node = (Node);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Cascader/base/store.js
var store_assign = (undefined && undefined.__assign) || function () {
    store_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return store_assign.apply(this, arguments);
};




var Store = /** @class */ (function () {
    function Store(options, value, config) {
        var _this = this;
        this.nodes = [];
        this.flatNodes = [];
        this.config = {};
        // 初始化节点状态，附加状态信息字段： _checked,_halfChecked,parent,disabled
        this._calcNodes = function (options, parent) {
            if (!options) {
                return [];
            }
            return options.map(function (option, index) {
                return new node(store_assign(store_assign({}, option), { _index: index }), _this.config, parent);
            });
        };
        // this.flatNodes 保存所有可能的选中项
        this._updateFlatNodes = function () {
            var leafOnly = !_this.config.changeOnSelect;
            _this.flatNodes = [];
            var traversal = function (option) {
                if (!option)
                    return;
                if (!leafOnly || option.isLeaf) {
                    _this.flatNodes.push(option);
                }
                if ((0,is/* isArray */.kJ)(option.children)) {
                    option.children.forEach(function (x) {
                        traversal(x);
                    });
                }
            };
            _this.nodes.forEach(function (node) {
                traversal(node);
            });
        };
        /**
         * values: 全部的选中值
         * 根据values更新节点状态。不包含在values的节点都设置为未选中状态
         * @memberof Store
         */
        this.setNodeCheckedByValue = function (initValues) {
            var valuesSet = transformValuesToSet(initValues);
            // 根据value设置节点初始选中状态
            _this.flatNodes.forEach(function (node) {
                var checked = false;
                if (_this.config.showParent) {
                    if (node.pathValue.some(function (_, index, arr) { return valueInSet(valuesSet, arr.slice(0, index + 1)); })) {
                        checked = true;
                    }
                }
                else if (valueInSet(valuesSet, node.pathValue)) {
                    checked = true;
                }
                node.setCheckedStateIgnoreDisabled(checked);
            });
        };
        /**
         * 为当前节点插入子节点。动态加载时候用到
         */
        this.appendOptionChildren = function (node, children) {
            if (children && node) {
                // const checked = node._checked;
                // node.setCheckedProperty(false);
                var options = _this._calcNodes(children, node);
                node.children = options;
                _this._updateFlatNodes();
                if (_this.config.changeOnSelect) {
                    // node.setCheckedProperty(checked);
                }
                else {
                    node.setCheckedState(false);
                }
            }
        };
        /**
         * 通过 value 查找对应的node节点。
         * value: 是路径节点的value组成的数组
         */
        this.findNodeByValue = function (value) {
            var targetNode = null;
            if (!value || !value.length) {
                return targetNode;
            }
            _this.flatNodes.some(function (node) {
                if (isEqualWith_default()(node.pathValue, value)) {
                    targetNode = node;
                }
            });
            return targetNode;
        };
        /**
         * 搜索所有label含有关键字的节点
         */
        this.searchNodeByLabel = function (inputStr) {
            if (!inputStr) {
                return _this.flatNodes;
            }
            var filterOption = _this.config.filterOption;
            var filterMethod = (0,is/* isFunction */.mf)(filterOption)
                ? filterOption
                : function (inputValue, node) {
                    return (0,is/* isString */.HD)(node.label) && node.label.indexOf(inputValue) > -1;
                };
            return _this.flatNodes.filter(function (item) {
                var pathNodes = item.getPathNodes();
                return pathNodes.some(function (node) {
                    return filterMethod(inputStr, node._data);
                });
            });
        };
        /** 获取所有节点 */
        this.getOptions = function () {
            return _this.nodes;
        };
        /** 获取所有选中状态的节点。 aggregation: 是否聚合节点 */
        this.getCheckedNodes = function () {
            if (_this.config.showParent) {
                return _this.getCheckedParentNodes();
            }
            return _this.flatNodes.filter(function (node) {
                return node._checked;
            });
        };
        // 按照父节点纬度聚合当前所有选中节点。
        this.getCheckedParentNodes = function () {
            var result = new Set();
            _this.flatNodes.forEach(function (node) {
                if (node._checked) {
                    var pathnodes = node.getPathNodes();
                    pathnodes.some(function (node) {
                        if (node._checked) {
                            if (!result.has(node)) {
                                result.add(node);
                            }
                            return true;
                        }
                    });
                }
            });
            return Array.from(result);
        };
        this.config = store_assign({}, config);
        var values = Array.isArray(value) ? value : [];
        this.nodes = this._calcNodes(options, null);
        // 根据nodes获取选中值
        this._updateFlatNodes();
        this.setNodeCheckedByValue(values);
    }
    return Store;
}());
/* harmony default export */ var store = (Store);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Cascader/util.js


var ValueSeparator = '__arco_cascader__';
var SHOW_PARENT = 'parent';
var SHOW_CHILD = 'child';
var PANEL_MODE = {
    cascader: 'cascader',
    select: 'select',
};
function isEmptyValue(value) {
    return !value || ((0,is/* isArray */.kJ)(value) && value.length === 0);
}
function getConfig(props) {
    return {
        showEmptyChildren: props.showEmptyChildren,
        changeOnSelect: props.changeOnSelect,
        lazyload: !!props.loadMore,
        fieldNames: props.fieldNames,
        filterOption: props.filterOption,
        showParent: props.mode === 'multiple' && !props.changeOnSelect && props.checkedStrategy === SHOW_PARENT,
    };
}
function getStore(props, value) {
    var tmp = value ? (Array.isArray(value[0]) ? value : [value]) : [];
    return new store(props.options || [], tmp, getConfig(props));
}
var transformValuesToSet = function (values) {
    var _values = values || [];
    var valuesSet = _values.reduce(function (set, next) {
        // 'next' could be a string.
        set.add([].concat(next).join(ValueSeparator));
        return set;
    }, new Set());
    return valuesSet;
};
var valueInSet = function (set, value) {
    var _value = value || [];
    return set.has(_value.join(ValueSeparator));
};
var removeValueFromSet = function (set, value) {
    var _value = value || [];
    return set.delete(_value.join(ValueSeparator));
};
var formatValue = function (value, isMultiple, store) {
    var _value = [];
    if (value === undefined) {
        _value = [];
    }
    else if (isMultiple) {
        _value = value;
    }
    else {
        _value = [value];
    }
    if (store && store.config.showParent) {
        var checkedNodes = store.getCheckedNodes();
        var valuesSet_1 = transformValuesToSet(checkedNodes.map(function (node) { return node.pathValue; }));
        var result_1 = [];
        var temp_1 = {};
        _value.map(function (v) {
            v.some(function (_, index, arr) {
                var curVal = arr.slice(0, index + 1);
                var pass = valueInSet(valuesSet_1, curVal);
                if (pass && !temp_1[curVal.join(ValueSeparator)]) {
                    result_1.push(curVal);
                    temp_1[curVal.join(ValueSeparator)] = 1;
                }
                return pass;
            });
        });
        return result_1;
    }
    return _value;
};
// change check status to false
var deny2Checked = function (option) {
    var deny = function (options) {
        return !Array.isArray(options)
            ? false
            : options.every(function (item) {
                if (item._checked || item.disabled) {
                    return true;
                }
                return deny(item.children);
            });
    };
    return option._halfChecked && deny(option === null || option === void 0 ? void 0 : option.children);
};
var getMultipleCheckValue = function (propsValue, store, option, _checked) {
    var checked = _checked && deny2Checked(option) ? false : _checked;
    var beforeValueSet = store.getCheckedNodes().reduce(function (set, node) {
        set.add(node.pathValue.join(ValueSeparator));
        return set;
    }, new Set());
    option.setCheckedState(checked);
    var checkedNodes = store.getCheckedNodes();
    var currentValue = checkedNodes.map(function (node) { return node.pathValue; });
    var currentValueSet = transformValuesToSet(currentValue);
    var newValueSet = new Set();
    return propsValue
        .filter(function (v) {
        // v 不在 beforeValueSet 中，说明 v 不包含对应的option。直接返回true，不应该清除掉。
        if (!valueInSet(beforeValueSet, v) || valueInSet(currentValueSet, v)) {
            newValueSet.add(v.join(ValueSeparator));
            return true;
        }
    })
        .concat(currentValue.filter(function (v) {
        return !valueInSet(newValueSet, v);
    }));
};

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_class/VirtualList/index.js + 4 modules
var VirtualList = __webpack_require__(20179);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/dom.js
var dom = __webpack_require__(53412);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Cascader/panel/list.js
var list_assign = (undefined && undefined.__assign) || function () {
    list_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return list_assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var list_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};













var getLegalActiveNode = function (options) {
    for (var index = 0; index < options.length; index++) {
        if (!options[index].disabled) {
            return options[index];
        }
    }
};
var getBaseActiveNode = function (currentNode) {
    if (currentNode && currentNode.disabled) {
        var node = currentNode;
        while (node.parent) {
            if (node.parent.disabled) {
                node = node.parent;
            }
            else {
                break;
            }
        }
        return node;
    }
    return currentNode;
};
var getLegalIndex = function (currentIndex, maxIndex) {
    if (currentIndex < 0) {
        return maxIndex;
    }
    if (currentIndex > maxIndex) {
        return 0;
    }
    return currentIndex;
};
var ListPanel = function (props) {
    var _a;
    var _b = list_read(useRefs(), 2), refWrapper = _b[0], setRefWrapper = _b[1];
    var forceUpdate = (0,useForceUpdate/* default */.Z)();
    var store = props.store, prefixCls = props.prefixCls, value = props.value, multiple = props.multiple, renderFooter = props.renderFooter, renderOption = props.renderOption, showEmptyChildren = props.showEmptyChildren, loadMore = props.loadMore, renderEmpty = props.renderEmpty, rtl = props.rtl, icons = props.icons;
    var _c = list_read((0,react.useState)(store.findNodeByValue(value && value[value.length - 1]) || null), 2), activeNode = _c[0], setActiveNode = _c[1];
    var options = store.getOptions();
    var triggerChange = function (newValue) {
        props.onChange && props.onChange(newValue);
    };
    var loadData = function (option) { return __awaiter(void 0, void 0, void 0, function () {
        var options_1, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(!option.isLeaf && (0,is/* isFunction */.mf)(loadMore) && !option.children)) return [3 /*break*/, 5];
                    option.setLoading(true);
                    forceUpdate();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, loadMore(option.pathValue, option.pathValue.length)];
                case 2:
                    options_1 = _a.sent();
                    store.appendOptionChildren(option, options_1);
                    store.setNodeCheckedByValue(props.value);
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [3 /*break*/, 4];
                case 4:
                    option.setLoading(false);
                    forceUpdate();
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var onClickOption = function (option, isEnterClick) {
        if (isEnterClick === void 0) { isEnterClick = true; }
        return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!option || option.disabled) {
                    return [2 /*return*/];
                }
                setActiveNode(option);
                loadData(option);
                // 在键盘上下左右键操作时,isEnterClick 是false，不触发triggerChange
                if (!multiple && isEnterClick) {
                    if (props.changeOnSelect || option.isLeaf) {
                        triggerChange([option.pathValue]);
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    var onMultipleChecked = function (option, checked) {
        var newValue = getMultipleCheckValue(props.value, store, option, checked);
        if (option === activeNode) {
            // setActiveNode 不会执行rerender，需要forceupdate
            forceUpdate();
        }
        setActiveNode(option);
        if (!props.changeOnSelect) {
            // 父子节点关联，选中复选框时执行loadMore，否则直接选中父节点
            loadData(option);
        }
        triggerChange(newValue);
    };
    var scrollToActiveNode = (0,react.useCallback)(function (targetNode) {
        var _a;
        if (targetNode === void 0) { targetNode = activeNode; }
        var current = targetNode;
        while (current) {
            (_a = refWrapper[current._level]) === null || _a === void 0 ? void 0 : _a.scrollTo({
                index: current._index,
                options: { block: 'nearest' },
            });
            current = current._level < 1 ? null : current.parent;
        }
    }, [activeNode]);
    var handleKeyDown = (0,react.useCallback)(function (e) {
        // e.stopPropagation();
        // 使用keycode，避免中文输入法输入时，触发enter,space等事件。
        // p.s 中文输入时，keycode 都是229
        var keyCode = e.keyCode || e.which;
        var nextActiveNode;
        switch (keyCode) {
            case keycode/* Esc.code */.AV.code: {
                e.preventDefault();
                props.onEsc();
                break;
            }
            case keycode/* ArrowDown.code */.K5.code:
            case keycode/* ArrowUp.code */.a2.code: {
                if (!activeNode) {
                    nextActiveNode = getLegalActiveNode(options);
                }
                else {
                    var baseActiveNode = getBaseActiveNode(activeNode);
                    var list = (baseActiveNode.parent && baseActiveNode.parent.children) || options;
                    var diff = keyCode === keycode/* ArrowDown.code */.K5.code ? 1 : -1;
                    var nextIndex = getLegalIndex(baseActiveNode._index + diff, list.length - 1);
                    while (nextIndex !== baseActiveNode._index) {
                        nextActiveNode = list[nextIndex];
                        if (nextActiveNode.disabled) {
                            nextIndex = getLegalIndex(nextIndex + diff, list.length - 1);
                        }
                        else {
                            break;
                        }
                    }
                }
                scrollToActiveNode(nextActiveNode);
                onClickOption(nextActiveNode, false);
                e.preventDefault();
                return false;
            }
            case keycode/* ArrowRight.code */.ol.code: {
                if (activeNode && !activeNode.disabled) {
                    var list = activeNode.children || [];
                    nextActiveNode = list[0] || activeNode;
                    onClickOption(nextActiveNode, false);
                }
                e.preventDefault();
                return false;
            }
            case keycode/* ArrowLeft.code */.Xd.code: {
                if (activeNode) {
                    var baseActiveNode = getBaseActiveNode(activeNode);
                    nextActiveNode = baseActiveNode.parent || baseActiveNode;
                }
                onClickOption(nextActiveNode, false);
                e.preventDefault();
                return false;
            }
            case keycode/* Enter.code */.Ce.code:
                if (activeNode) {
                    if (multiple) {
                        onMultipleChecked(activeNode, !activeNode._checked);
                    }
                    else {
                        onClickOption(activeNode);
                    }
                }
                e.preventDefault();
                return false;
            default:
                break;
        }
    }, [activeNode]);
    (0,useUpdate/* default */.Z)(function () {
        setActiveNode(function (activeNode) {
            // store 改变时候，更新下activeNode.如果当前activeNode不存在于store里了，就设置为null
            var newActiveNode;
            if (activeNode && activeNode.pathValue && activeNode.pathValue.length) {
                var values = activeNode.pathValue;
                var parent_1 = { children: options };
                values.map(function (value) {
                    var list = parent_1.children || [];
                    var item = list.find(function (x) { return x.value === value; });
                    if (item) {
                        parent_1 = item;
                        newActiveNode = item;
                    }
                });
            }
            return newActiveNode;
        });
    }, [store]);
    (0,react.useEffect)(function () {
        if (props.popupVisible && options.length) {
            setTimeout(scrollToActiveNode);
        }
    }, [props.popupVisible]);
    (0,react.useEffect)(function () {
        var target = props.getTriggerElement();
        if (!target) {
            return;
        }
        if (props.popupVisible) {
            (0,dom.on)(target, 'keydown', handleKeyDown);
        }
        else {
            (0,dom/* off */.S1)(target, 'keydown', handleKeyDown);
        }
        return function () {
            (0,dom/* off */.S1)(target, 'keydown', handleKeyDown);
        };
    }, [props.popupVisible, handleKeyDown]);
    var menus = (function () {
        var list = [options];
        var pathNodes = activeNode ? activeNode.getPathNodes() : [];
        pathNodes.forEach(function (option) {
            option && option.children && list.push(option.children);
        });
        return list;
    })();
    var dropdownColumnRender = (0,is/* isFunction */.mf)(props.dropdownColumnRender)
        ? props.dropdownColumnRender
        : function (menu) { return menu; };
    return !menus.length || !((_a = menus[0]) === null || _a === void 0 ? void 0 : _a.length) ? (react.createElement(react.Fragment, null, renderEmpty())) : (react.createElement(TransitionGroup/* default */.Z, { component: react.Fragment }, menus.map(function (list, level) {
        var _a, _b, _c;
        var footer = renderFooter ? renderFooter(level, activeNode || null) : null;
        return list.length === 0 && !showEmptyChildren ? null : (react.createElement(CSSTransition/* default */.Z, { key: level, timeout: {
                enter: 300,
                exit: 0,
            }, classNames: "cascaderSlide", onEnter: function (e) {
                e.style.marginLeft = "-" + e.scrollWidth + "px";
            }, onEntering: function (e) {
                e.style.marginLeft = "0px";
            }, onEntered: function (e) {
                e.style.marginLeft = '';
            } },
            react.createElement("div", { className: (0,classNames/* default */.Z)(prefixCls + "-list-column", (_a = {},
                    _a[prefixCls + "-list-column-virtual"] = props.virtualListProps && props.virtualListProps.threshold !== null,
                    _a[prefixCls + "-list-column-rtl"] = rtl,
                    _a)), style: list_assign({ zIndex: menus.length - level }, props.dropdownMenuColumnStyle) }, dropdownColumnRender(react.createElement("div", { className: (0,classNames/* default */.Z)(prefixCls + "-list-wrapper", (_b = {},
                    _b[prefixCls + "-list-wrapper-with-footer"] = footer !== null,
                    _b)) },
                list.length === 0 ? (renderEmpty && renderEmpty(props.virtualListProps ? '100%' : 120)) : (react.createElement(VirtualList/* default */.Z, list_assign({ needFiller: false, threshold: props.virtualListProps ? 100 : null, data: list, isStaticItemHeight: true, itemKey: "value" }, ((0,is/* isObject */.Kn)(props.virtualListProps) ? props.virtualListProps : {}), { wrapper: "ul", role: "menu", ref: function (node) { return setRefWrapper(node, level); }, className: (0,classNames/* default */.Z)(prefixCls + "-list", prefixCls + "-list-select", (_c = {},
                        _c[prefixCls + "-list-multiple"] = multiple,
                        _c[prefixCls + "-list-rtl"] = rtl,
                        _c)) }), function (option) {
                    var _a;
                    var isActive = false;
                    if (activeNode) {
                        isActive = activeNode.pathValue[level] === option.value;
                    }
                    return (react.createElement("li", { tabIndex: 0, role: "menuitem", "aria-haspopup": !option.isLeaf, "aria-expanded": isActive && !option.isLeaf, "aria-disabled": option.disabled, key: option.value, title: (0,is/* isString */.HD)(option.label) ? option.label : undefined, className: (0,classNames/* default */.Z)(prefixCls + "-list-item", (_a = {},
                            _a[prefixCls + "-list-item-active"] = isActive,
                            _a[prefixCls + "-list-item-disabled"] = option.disabled,
                            _a)) },
                        react.createElement(panel_option, { prefixCls: prefixCls, rtl: rtl, multiple: multiple, option: option, 
                            // 叶子节点被选中
                            selected: !multiple &&
                                option.isLeaf &&
                                isEqualWith_default()(props.value, option.pathValue), icons: icons, onMouseEnter: function () {
                                if (option.disabled) {
                                    return;
                                }
                                if (props.expandTrigger === 'hover') {
                                    setActiveNode(option);
                                    !option.isLeaf && loadData(option);
                                }
                            }, renderOption: renderOption &&
                                (function () {
                                    return renderOption(option._data, level);
                                }), onClickOption: function () {
                                if (option.isLeaf && multiple && !option.disableCheckbox) {
                                    onMultipleChecked(option, !option._checked);
                                }
                                else {
                                    onClickOption(option);
                                }
                            }, onMultipleChecked: function (checked) {
                                onMultipleChecked(option, checked);
                            }, onDoubleClickOption: props.onDoubleClickOption })));
                })),
                footer && (react.createElement("div", { className: prefixCls + "-list-footer", onMouseDown: function (e) {
                        // 这里是为了阻止冒泡到面板节点的onMousedown事件。因为弹出层会阻止默认行为，避免选择框失去焦点
                        // 如果这里不阻止冒泡，footer里如果渲染了input标签，将无法被focus
                        e.stopPropagation();
                    } }, footer))), level))));
    })));
};
/* harmony default export */ var list = (ListPanel);

// EXTERNAL MODULE: ./node_modules/scroll-into-view-if-needed/es/index.js + 1 modules
var es = __webpack_require__(75469);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useIsFirstRender.js
var useIsFirstRender = __webpack_require__(91626);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Cascader/panel/search-panel.js
var search_panel_assign = (undefined && undefined.__assign) || function () {
    search_panel_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return search_panel_assign.apply(this, arguments);
};
var search_panel_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};












var search_panel_getLegalIndex = function (currentIndex, maxIndex) {
    if (currentIndex < 0) {
        return maxIndex;
    }
    if (currentIndex > maxIndex) {
        return 0;
    }
    return currentIndex;
};
var formatLabel = function (inputValue, label, prefixCls) {
    var dom = label;
    if ((0,is/* isString */.HD)(label)) {
        var index = label.toUpperCase().indexOf(inputValue.toUpperCase());
        if (index > -1) {
            var prefix = label.substr(0, index);
            var suffix = label.substr(index + inputValue.length);
            dom = (react.createElement(react.Fragment, null,
                prefix,
                react.createElement("span", { className: prefixCls + "-highlight" }, label.substr(index, inputValue.length)),
                suffix));
        }
    }
    return dom;
};
var SearchPanel = function (props) {
    var _a;
    var store = props.store, prefixCls = props.prefixCls, multiple = props.multiple, onChange = props.onChange, inputValue = props.inputValue, renderEmpty = props.renderEmpty, style = props.style, defaultActiveFirstOption = props.defaultActiveFirstOption, rtl = props.rtl, icons = props.icons;
    var value = props.value || [];
    var _b = search_panel_read((0,react.useState)(store.searchNodeByLabel(inputValue) || []), 2), options = _b[0], setOptions = _b[1];
    var refActiveItem = (0,react.useRef)();
    // 用来标示是否需要scrollIntoView。如果是鼠标hover，不需要滚动。
    var isKeyboardHover = (0,react.useRef)();
    var isFirstRender = (0,useIsFirstRender/* default */.Z)();
    // 保存键盘操作的目标节点
    var _c = search_panel_read((0,react.useState)(defaultActiveFirstOption ? 0 : -1), 2), currentHoverIndex = _c[0], setCurrentHoverIndex = _c[1];
    var handleSearchOptionClick = function (option, checked, e) {
        e.stopPropagation();
        if (option.disabled) {
            return;
        }
        if (multiple) {
            var checkedValues = getMultipleCheckValue(props.value, store, option, checked);
            onChange && onChange(checkedValues);
        }
        else {
            onChange && onChange([option.pathValue]);
        }
    };
    (0,useUpdate/* default */.Z)(function () {
        setOptions(store.searchNodeByLabel(inputValue));
    }, [inputValue, store]);
    (0,useUpdate/* default */.Z)(function () {
        setCurrentHoverIndex(function (currentIndex) {
            if (currentIndex > options.length - 1) {
                return defaultActiveFirstOption ? 0 : -1;
            }
            return currentIndex;
        });
    }, [options]);
    (0,react.useEffect)(function () {
        var target = props.getTriggerElement();
        if (!target) {
            return;
        }
        var handleKeyDown = function (e) {
            e.stopPropagation();
            // 使用keycode，避免中文输入法输入时，触发enter,space等事件。
            // p.s 中文输入时，keycode 都是229
            var keyCode = e.keyCode || e.which;
            switch (keyCode) {
                case keycode/* Esc.code */.AV.code: {
                    props.onEsc();
                    return false;
                }
                case keycode/* ArrowDown.code */.K5.code:
                case keycode/* ArrowUp.code */.a2.code: {
                    isKeyboardHover.current = true;
                    var diff = keycode/* ArrowDown.code */.K5.code === keyCode ? 1 : -1;
                    var nextIndex = search_panel_getLegalIndex(currentHoverIndex + diff, options.length - 1);
                    while (nextIndex !== currentHoverIndex) {
                        var item_1 = options[nextIndex];
                        if (item_1.disabled) {
                            nextIndex = search_panel_getLegalIndex(nextIndex + diff, options.length - 1);
                        }
                        else {
                            break;
                        }
                    }
                    setCurrentHoverIndex(nextIndex);
                    return false;
                }
                case keycode/* Enter.code */.Ce.code:
                    var item_2 = options[currentHoverIndex];
                    if (item_2) {
                        var isChecked = value.some(function (x) {
                            return isEqualWith_default()(x, item_2.pathValue);
                        });
                        handleSearchOptionClick(item_2, !isChecked, e);
                    }
                    return false;
                default:
                    break;
            }
        };
        (0,dom.on)(target, 'keydown', handleKeyDown);
        return function () {
            (0,dom/* off */.S1)(target, 'keydown', handleKeyDown);
        };
    }, [options, currentHoverIndex, value]);
    (0,react.useEffect)(function () {
        var _a;
        var target = refActiveItem.current;
        if (target && (isKeyboardHover.current || isFirstRender)) {
            (0,es/* default */.Z)(target, {
                behavior: 'instant',
                block: 'nearest',
                scrollMode: 'if-needed',
                boundary: (_a = target.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode,
            });
        }
    }, [currentHoverIndex, options]);
    refActiveItem.current = null;
    return options.length ? (react.createElement("div", { className: prefixCls + "-list-wrapper" },
        react.createElement(VirtualList/* default */.Z, search_panel_assign({ needFiller: false, wrapper: "ul", role: "menu", style: style, data: options, isStaticItemHeight: true, threshold: props.virtualListProps ? 100 : null }, ((0,is/* isObject */.Kn)(props.virtualListProps) ? props.virtualListProps : {}), { onMouseMove: function () {
                isKeyboardHover.current = false;
            }, className: (0,classNames/* default */.Z)(prefixCls + "-list", prefixCls + "-list-search", (_a = {},
                _a[prefixCls + "-list-multiple"] = multiple,
                _a[prefixCls + "-list-rtl"] = rtl,
                _a)) }), function (item, i) {
            var _a;
            var pathNodes = item.getPathNodes();
            var pathLabel = pathNodes.map(function (x) { return x.label; }).join(' / ');
            var label = (0,is/* isFunction */.mf)(props.renderOption)
                ? props.renderOption(inputValue, item._data)
                : formatLabel(inputValue, pathLabel, prefixCls);
            var isChecked = item._checked;
            return (react.createElement("li", { title: (0,is/* isString */.HD)(label) ? label : (0,is/* isString */.HD)(pathLabel) ? pathLabel : undefined, role: "menuitem", "aria-disabled": item.disabled, ref: function (node) {
                    if (i === currentHoverIndex) {
                        refActiveItem.current = node;
                    }
                    if (isChecked && !refActiveItem.current) {
                        refActiveItem.current = node;
                    }
                }, className: (0,classNames/* default */.Z)(prefixCls + "-list-search-item", (_a = {},
                    _a[prefixCls + "-list-search-item-active"] = isChecked,
                    _a[prefixCls + "-list-search-item-hover"] = i === currentHoverIndex,
                    _a[prefixCls + "-list-search-item-disabled"] = item.disabled,
                    _a)), onClick: function (e) {
                    handleSearchOptionClick(item, !isChecked, e);
                }, key: i, onMouseEnter: function () {
                    if (!isKeyboardHover.current && !item.disabled) {
                        setCurrentHoverIndex(i);
                    }
                }, onMouseLeave: function () {
                    if (!isKeyboardHover.current && !item.disabled) {
                        setCurrentHoverIndex(defaultActiveFirstOption ? 0 : -1);
                    }
                } },
                react.createElement("div", { className: prefixCls + "-list-item-label" }, (0,is/* isFunction */.mf)(props.renderOption) ? (label) : multiple ? (react.createElement(Checkbox/* default */.Z, { checked: isChecked, disabled: item.disabled }, label)) : (react.createElement(react.Fragment, null,
                    label,
                    isChecked && (react.createElement("span", { className: prefixCls + "-check-icon" }, icons.checked)))))));
        }))) : (react.createElement(react.Fragment, null, renderEmpty && renderEmpty()));
};
/* harmony default export */ var search_panel = (SearchPanel);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/ConfigProvider/index.js + 1 modules
var ConfigProvider = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_class/select-view.js + 1 modules
var select_view = __webpack_require__(69404);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeValue.js
var useMergeValue = __webpack_require__(15955);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Cascader/hook/useRefCurrent.js
var useRefCurrent_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var useRefCurrent_spreadArray = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};



function useCurrentRef(initFunc, deps) {
    var ref = (0,react.useRef)(null);
    var forceUdpate = (0,useForceUpdate/* default */.Z)();
    if (!ref.current) {
        ref.current = initFunc();
    }
    (0,useUpdate/* default */.Z)(function () {
        ref.current = initFunc();
        forceUdpate();
    }, useRefCurrent_spreadArray([], useRefCurrent_read(deps), false));
    return ref.current;
}
/* harmony default export */ var useRefCurrent = (useCurrentRef);

// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useMergeProps.js
var useMergeProps = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/es/_util/hooks/useId.js
var useId = __webpack_require__(74732);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLeft/index.js
var IconLeft = __webpack_require__(42355);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconRight/index.js
var IconRight = __webpack_require__(826);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconLoading/index.js
var IconLoading = __webpack_require__(69049);
// EXTERNAL MODULE: ./node_modules/@arco-design/web-react/icon/react-icon/IconCheck/index.js
var IconCheck = __webpack_require__(34553);
;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Cascader/cascader.js
var cascader_assign = (undefined && undefined.__assign) || function () {
    cascader_assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return cascader_assign.apply(this, arguments);
};
var cascader_read = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




















var DefaultFieldNames = {
    label: 'label',
    value: 'value',
    isLeaf: 'isLeaf',
    children: 'children',
    disabled: 'disabled',
};
var defaultProps = {
    options: [],
    bordered: true,
    fieldNames: DefaultFieldNames,
    trigger: 'click',
    expandTrigger: 'click',
    checkedStrategy: SHOW_CHILD,
    defaultActiveFirstOption: true,
};
var triggerPopupAlign = { bottom: 4 };
function Cascader(baseProps, ref) {
    var _a = (0,react.useContext)(ConfigProvider/* ConfigContext */.E_), getPrefixCls = _a.getPrefixCls, renderEmpty = _a.renderEmpty, componentConfig = _a.componentConfig, rtl = _a.rtl;
    var props = (0,useMergeProps/* default */.Z)(baseProps, defaultProps, componentConfig === null || componentConfig === void 0 ? void 0 : componentConfig.Cascader);
    var disabled = props.disabled, renderFormat = props.renderFormat, getPopupContainer = props.getPopupContainer, children = props.children, triggerProps = props.triggerProps, expandTrigger = props.expandTrigger, icons = props.icons;
    var iconsMap = {
        loading: (icons === null || icons === void 0 ? void 0 : icons.loading) || react.createElement(IconLoading/* default */.Z, null),
        checked: (icons === null || icons === void 0 ? void 0 : icons.checked) || react.createElement(IconCheck/* default */.Z, null),
        next: (icons === null || icons === void 0 ? void 0 : icons.next) || (rtl ? react.createElement(IconLeft/* default */.Z, null) : react.createElement(IconRight/* default */.Z, null)),
    };
    var prefixCls = getPrefixCls('cascader');
    var isMultiple = props.mode === 'multiple';
    var timerRef = (0,react.useRef)(null);
    var forceUpdate = (0,useForceUpdate/* default */.Z)();
    var store = useRefCurrent(function () {
        return getStore(props, formatValue('value' in props ? props.value : props.defaultValue, isMultiple));
    }, [JSON.stringify(getConfig(props)), props.options]);
    var _b = cascader_read((0,react.useState)(function () {
        return 'value' in props
            ? formatValue(props.value, isMultiple, store)
            : 'defaultValue' in props
                ? formatValue(props.defaultValue, isMultiple, store)
                : [];
    }), 2), stateValue = _b[0], setValue = _b[1];
    var mergeValue = 'value' in props ? formatValue(props.value, isMultiple, store) : stateValue;
    var _c = cascader_read((0,useMergeValue/* default */.Z)(false, {
        value: props.popupVisible,
        defaultValue: props.defaultPopupVisible,
    }), 2), popupVisible = _c[0], setPopupVisible = _c[1];
    var _d = cascader_read((0,useMergeValue/* default */.Z)('', {
        value: 'inputValue' in props ? props.inputValue || '' : undefined,
    }), 3), inputValue = _d[0], setInputValue = _d[1], stateInputValue = _d[2];
    // 触发 onInputValueChange 回调的值
    var refOnInputChangeCallbackValue = (0,react.useRef)(inputValue);
    // 触发 onInputValueChange 回调的原因
    var refOnInputChangeCallbackReason = (0,react.useRef)(null);
    var selectRef = (0,react.useRef)(null);
    // 暂存被选中的值对应的节点。仅在onSearch的时候用到
    // 避免出现下拉列表改变，之前选中的option找不到对应的节点，展示上会出问题。
    var stashNodes = (0,react.useRef)((store === null || store === void 0 ? void 0 : store.getCheckedNodes()) || []);
    // Unique ID of this instance
    var instancePopupID = (0,useId/* default */.Z)(prefixCls + "-popup-");
    // 尝试更新 inputValue，触发 onInputValueChange
    var tryUpdateInputValue = function (value, reason) {
        if (value !== refOnInputChangeCallbackValue.current) {
            setInputValue(value);
            refOnInputChangeCallbackValue.current = value;
            refOnInputChangeCallbackReason.current = reason;
            props.onInputValueChange && props.onInputValueChange(value, reason);
        }
    };
    // 在 inputValue 变化时，适时触发 onSearch
    (0,react.useEffect)(function () {
        var reason = refOnInputChangeCallbackReason.current;
        if (stateInputValue === inputValue && (reason === 'manual' || reason === 'optionListHide')) {
            props.onSearch && props.onSearch(inputValue, reason);
        }
        if (inputValue !== refOnInputChangeCallbackValue.current) {
            refOnInputChangeCallbackValue.current = inputValue;
        }
    }, [inputValue]);
    (0,react.useEffect)(function () {
        var clearTimer = function () {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        };
        if (!popupVisible && inputValue) {
            if (timerRef.current) {
                clearTimer();
            }
            timerRef.current = setTimeout(function () {
                tryUpdateInputValue('', 'optionListHide');
                timerRef.current = null;
            }, 200);
        }
        return function () {
            clearTimer();
        };
    }, [popupVisible]);
    (0,useUpdate/* default */.Z)(function () {
        if ('value' in props && props.value !== stateValue) {
            // don't to use formatValue(x, y, store)
            // we just need to get the value in a valid format, and update it to store nodes
            var newValue = formatValue(props.value, isMultiple);
            store.setNodeCheckedByValue(newValue);
            setValue(newValue);
        }
    }, [props.value, isMultiple]);
    (0,react.useImperativeHandle)(ref, function () { return selectRef.current; }, []);
    var updateStashNodes = function (nodes) {
        stashNodes.current = Array.from(new Set([].concat(nodes, stashNodes.current)));
    };
    var getSelectedOptionsByValue = function (values) {
        var result = [];
        var valuesSet = transformValuesToSet(values);
        var findValue = function (nodes) {
            nodes.some(function (node) {
                if (valueInSet(valuesSet, node.pathValue)) {
                    result.push(node.getPathNodes().map(function (x) { return x._data; }));
                    removeValueFromSet(valuesSet, node.pathValue);
                }
                if (!valuesSet.size) {
                    return true;
                }
            });
        };
        findValue(store.getCheckedNodes());
        if (valuesSet.size) {
            findValue(stashNodes.current);
        }
        return result;
    };
    var handleVisibleChange = (0,react.useCallback)(function (newVisible) {
        if (newVisible !== popupVisible) {
            props.onVisibleChange && props.onVisibleChange(newVisible);
            if (!('popupVisible' in props)) {
                setPopupVisible(newVisible);
            }
        }
    }, [props.onVisibleChange, popupVisible]);
    var renderText = (0,react.useCallback)(function (value) {
        var _a;
        // store 中不存在时，从stashNodes.current中找一下对应节点
        var options = getSelectedOptionsByValue([value])[0] || [];
        var text;
        var valueShow = (0,is/* isArray */.kJ)(value) ? value.map(function (x) { return String(x); }) : [];
        if (options.length) {
            valueShow = options.map(function (x) { return x.label; });
        }
        if ((0,is/* isFunction */.mf)(renderFormat)) {
            text = renderFormat(valueShow);
        }
        else if (valueShow.every(function (v) { return (0,is/* isString */.HD)(v); })) {
            text = valueShow.join(' / ');
        }
        else {
            text = valueShow.reduce(function (total, item, index) {
                return total.concat(index === 0 ? [item] : [' / ', item]);
            }, []);
        }
        return {
            text: text || '',
            disabled: (_a = options[options.length - 1]) === null || _a === void 0 ? void 0 : _a.disabled,
        };
    }, [store, renderFormat]);
    var handleChange = function (newValue, trigger) {
        var _a;
        if (trigger === 'panel' &&
            (0,is/* isObject */.Kn)(props.showSearch) &&
            !props.showSearch.retainInputValueWhileSelect &&
            isMultiple) {
            tryUpdateInputValue('', 'optionChecked');
        }
        var onChange = props.onChange, changeOnSelect = props.changeOnSelect, expandTrigger = props.expandTrigger;
        var isSame = mergeValue === newValue;
        if (isSame) {
            return;
        }
        if (!isMultiple) {
            store.setNodeCheckedByValue(newValue);
        }
        updateStashNodes(store.getCheckedNodes());
        var selectedOptions = getSelectedOptionsByValue(newValue);
        var _value = isMultiple ? newValue : newValue[0];
        var _selectedOptions = isMultiple ? selectedOptions : selectedOptions[0];
        if (!isMultiple) {
            if (inputValue) {
                // 单选时选择搜索项，直接关闭面板
                handleVisibleChange(false);
            }
            else if ((selectedOptions[0] && ((_a = selectedOptions[0][selectedOptions[0].length - 1]) === null || _a === void 0 ? void 0 : _a.isLeaf)) ||
                (changeOnSelect && expandTrigger === 'hover')) {
                handleVisibleChange(false);
            }
        }
        if ('value' in props) {
            store.setNodeCheckedByValue(mergeValue);
            // 受控触发更新，回到选中前的状态。
            forceUpdate();
        }
        else {
            setValue(newValue);
        }
        onChange &&
            onChange(_value, _selectedOptions, {
                dropdownVisible: popupVisible,
            });
    };
    var onRemoveCheckedItem = function (item, index, e) {
        e.stopPropagation();
        if (item.disabled) {
            return;
        }
        var newValue = mergeValue.filter(function (_, i) { return i !== index; });
        store.setNodeCheckedByValue(newValue);
        handleChange(newValue);
    };
    var renderEmptyEle = function (width) {
        var wd = width || (selectRef.current && selectRef.current.getWidth());
        return (react.createElement("div", { className: prefixCls + "-list-empty", style: { width: wd } }, props.notFoundContent || renderEmpty('Cascader')));
    };
    var renderPopup = function () {
        var _a;
        // 远程搜索时是否以搜索面板展示搜索结果
        var panelMode = (0,is/* isObject */.Kn)(props.showSearch) ? props.showSearch.panelMode : undefined;
        var showSearchPanel = panelMode === PANEL_MODE.select
            ? true
            : panelMode === PANEL_MODE.cascader
                ? false
                : !(0,is/* isFunction */.mf)(props.onSearch) && !!inputValue;
        var width = selectRef.current && selectRef.current.getWidth();
        var dropdownRender = (0,is/* isFunction */.mf)(props.dropdownRender) ? props.dropdownRender : function (menu) { return menu; };
        return (react.createElement("div", { id: instancePopupID, className: (0,classNames/* default */.Z)(prefixCls + "-popup", props.dropdownMenuClassName, (_a = {},
                _a[prefixCls + "-popup-trigger-hover"] = props.expandTrigger === 'hover',
                _a)) }, dropdownRender(react.createElement("div", { className: prefixCls + "-popup-inner", onMouseDown: function (e) { return e.preventDefault(); } }, showSearchPanel ? (react.createElement(search_panel, { style: { minWidth: width }, store: store, inputValue: inputValue, renderEmpty: function () { return renderEmptyEle(width); }, multiple: isMultiple, onChange: function (value) {
                handleChange(value, 'panel');
            }, prefixCls: prefixCls, rtl: rtl, onEsc: function () {
                handleVisibleChange(false);
            }, renderOption: ((0,is/* isObject */.Kn)(props.showSearch) && props.showSearch.renderOption) || undefined, 
            // TODO 组件重构，解耦面板选择和输入框，面板可独立使用
            getTriggerElement: function () { var _a; return (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.dom; }, value: mergeValue, virtualListProps: props.virtualListProps, defaultActiveFirstOption: props.defaultActiveFirstOption, icons: iconsMap })) : (react.createElement(list, { dropdownMenuColumnStyle: props.dropdownMenuColumnStyle, virtualListProps: props.virtualListProps, expandTrigger: expandTrigger, store: store, dropdownColumnRender: props.dropdownColumnRender, renderOption: props.renderOption, changeOnSelect: props.changeOnSelect, showEmptyChildren: props.showEmptyChildren || !!props.loadMore, multiple: isMultiple, onChange: function (value) {
                handleChange(value, 'panel');
            }, loadMore: props.loadMore, prefixCls: prefixCls, rtl: rtl, getTriggerElement: function () { var _a; return (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.dom; }, renderEmpty: renderEmptyEle, popupVisible: popupVisible, value: mergeValue, renderFooter: props.renderFooter, icons: iconsMap, onEsc: function () {
                handleVisibleChange(false);
            }, onDoubleClickOption: function () {
                if (props.changeOnSelect && !isMultiple) {
                    handleVisibleChange(false);
                }
            } }))))));
    };
    var updateSelectedValues = function (value) {
        handleChange(value);
    };
    var renderView = function (eleView) {
        return (react.createElement(Trigger/* default */.Z, cascader_assign({ popup: renderPopup, trigger: props.trigger, disabled: disabled, getPopupContainer: getPopupContainer, position: rtl ? 'br' : 'bl', classNames: "slideDynamicOrigin", popupAlign: triggerPopupAlign, 
            // 动态加载时，unmountOnExit 默认为false。
            unmountOnExit: 'unmountOnExit' in props ? props.unmountOnExit : !(0,is/* isFunction */.mf)(props.loadMore), popupVisible: popupVisible }, triggerProps, { onVisibleChange: handleVisibleChange }), eleView));
    };
    return children ? (renderView(children)) : (react.createElement(select_view/* default */.Z, cascader_assign({}, props, { ref: selectRef, ariaControls: instancePopupID, popupVisible: popupVisible, value: isMultiple ? mergeValue : mergeValue && mergeValue[0], inputValue: inputValue, rtl: rtl, 
        // other
        isEmptyValue: isEmptyValue(mergeValue), prefixCls: prefixCls, isMultiple: isMultiple, renderText: renderText, onRemoveCheckedItem: onRemoveCheckedItem, onSort: updateSelectedValues, renderView: renderView, onClear: function (e) {
            var _a;
            e.stopPropagation();
            if (!isMultiple) {
                handleChange([]);
            }
            else {
                var nodes = store.getCheckedNodes();
                var newValue = nodes.filter(function (x) { return x.disabled; }).map(function (x) { return x.pathValue; });
                store.setNodeCheckedByValue(newValue);
                handleChange(newValue);
            }
            (_a = props.onClear) === null || _a === void 0 ? void 0 : _a.call(props, !!popupVisible);
        }, onKeyDown: function (e) {
            var _a;
            if (disabled) {
                return;
            }
            e.stopPropagation();
            var keyCode = e.keyCode || e.which;
            if (keyCode === keycode/* Enter.code */.Ce.code && !popupVisible) {
                handleVisibleChange(true);
                e.preventDefault();
            }
            if (keyCode === keycode/* Tab.code */.OK.code && popupVisible) {
                handleVisibleChange(false);
            }
            (_a = props.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(props, e);
        }, 
        // onFocus={this.onFocusInput}
        onChangeInputValue: function (v) {
            tryUpdateInputValue(v, 'manual');
            // tab键 focus 到输入框，此时下拉框未显示。如果输入值，展示下拉框
            if (!popupVisible) {
                handleVisibleChange(true);
            }
        } })));
}
var CascaderComponent = (0,react.forwardRef)(Cascader);
CascaderComponent.displayName = 'Cascader';
/* harmony default export */ var cascader = (CascaderComponent);

;// CONCATENATED MODULE: ./node_modules/@arco-design/web-react/es/Cascader/index.js

/* harmony default export */ var es_Cascader = (cascader);



/***/ }),

/***/ 86556:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),

/***/ 28483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(25063);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 42980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    assignMergeValue = __webpack_require__(86556),
    baseFor = __webpack_require__(28483),
    baseMergeDeep = __webpack_require__(59783),
    isObject = __webpack_require__(13218),
    keysIn = __webpack_require__(81704),
    safeGet = __webpack_require__(36390);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),

/***/ 59783:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(86556),
    cloneBuffer = __webpack_require__(64626),
    cloneTypedArray = __webpack_require__(77133),
    copyArray = __webpack_require__(278),
    initCloneObject = __webpack_require__(38517),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isArrayLikeObject = __webpack_require__(29246),
    isBuffer = __webpack_require__(44144),
    isFunction = __webpack_require__(23560),
    isObject = __webpack_require__(13218),
    isPlainObject = __webpack_require__(66827),
    isTypedArray = __webpack_require__(36719),
    safeGet = __webpack_require__(36390),
    toPlainObject = __webpack_require__(59881);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),

/***/ 25063:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 36390:
/***/ (function(module) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),

/***/ 29246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98612),
    isObjectLike = __webpack_require__(37005);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 28368:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939);

/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
}

module.exports = isEqualWith;


/***/ }),

/***/ 66827:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    getPrototype = __webpack_require__(85924),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 82492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMerge = __webpack_require__(42980),
    createAssigner = __webpack_require__(21463);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),

/***/ 59881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keysIn = __webpack_require__(81704);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ })

}]);